"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Global+Footer
 */
var React = require("react");
var Link_1 = require("./Link");
/**
 * OUI footer component.
 *
 * @oui-component Footer
 */
var Footer = function (_a) {
    var links = _a.links, copyright = _a.copyright, children = _a.children, testId = _a.testId, rest = __rest(_a, ["links", "copyright", "children", "testId"]);
    var linksContainer;
    // Wrap provided links to apply spacing.
    if (links && links.length) {
        var wrappedLinks = links.map(function (footerLinkProps, i) {
            var linkClasses = "oui-display-inline-block oui-padding oui-padding-remove-left oui-padding-remove-vertical";
            return (React.createElement("span", { key: i, className: linkClasses },
                React.createElement(Link_1.default, __assign({}, footerLinkProps.props), footerLinkProps.content)));
        });
        linksContainer = (React.createElement("div", { className: "oui-margin-bottom oui-footer-links" }, wrappedLinks));
    }
    var wrappedExtraContent = children ? (React.createElement("div", { className: "oui-margin-bottom" }, children)) : ("");
    return (React.createElement("footer", __assign({ className: "oui-padding oui-background-muted oui-width-1-1", "data-test-id": testId }, rest),
        wrappedExtraContent,
        linksContainer,
        React.createElement("div", null, copyright)));
};
/**
 * A Footer component.
 */
exports.default = Footer;
//# sourceMappingURL=Footer.js.map